<template>
    <div v-if="vraag">
        <v-layout pa-2 class="question" mt-5 wrap>
            <v-flex xs12 sm8>{{ vraag.omschrijving }}</v-flex>
            <v-flex xs12 pl-3 sm4>
                <v-select @change="answerChanged($event)" :rules="rules" v-model="v.reactie"
                    :items="['ja', 'nee']"></v-select>
            </v-flex>
        </v-layout>

        <div v-for="child in children" :key="child.id">
            <TreeSelect v-if="showChild(child)" :rules="rules" :tree="tree" :vraag-id="child.id"
                />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    name: "TreeSelect",
    props: {
        rules: {
            type: Array,
            required: false
        },
        tree: Array,
        vraagId: {
            type: Number,
            required: true
        },
        value: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters({
            vragenlijst: "vragenlijst",
        }),
        vraag() {
            return this.tree.find(q => q.id === this.vraagId);
        },
        children() {
            //return this.tree.filter(q => q.vraagid === this.vraagId);
             return this.tree.filter(q => q.vraagid === this.v.id && (q.criteria === this.v.reactie || !q.criteria) && this.v.reactie);
        },
        
        v() {
            return this.vragenlijst.find(v => v.id === this.vraagId) || {id: this.vraagId};
        }
    },
    methods: {
        showChild(child) {
        
            if (!child.criteria) return true;
            return this.v.reactie === child.criteria;
        },
        ...mapActions(["updateAntwoorden", "removeAntwoorden"]),
        answerChanged(antwoord) {

       
            // Recursief alle onderliggende vraag-ids verzamelen
            const onderliggendeIds = this.collectChildIds(this.vraag.id);
            if (onderliggendeIds.length > 0) {
                this.removeAntwoorden(onderliggendeIds);
            }
            // Update huidig antwoord
            let res = [];
            res.push({ id: this.vraag.id, reactie: antwoord });
            this.updateAntwoorden(res);
        },
        collectChildIds(parentId) {
            const ids = [];
            const children = this.tree.filter(q => q.vraagid === parentId);
            for (const child of children) {
                ids.push(child.id);
                ids.push(...this.collectChildIds(child.id));
            }
            return ids;
        }
    }
};
</script>